export default {
  searchHistory: [],
  programFilterHistory: [],
  cartCache: false
}
